<n-slide-window
    [visible]="show"
    (visibleChange)="show = $event; showChange.emit(show)"
    width="600px">
    <n-header>
        <h1>
            {{settingTitle}}
            <n-help-link key="alarmSound"></n-help-link>
        </h1>
    </n-header>
    <div class="setting_instrct">
            {{instrction}}
    </div>
    <div class="setting_instrct">
        {{alarmLevel}}&nbsp;&nbsp;&nbsp;
        <n-checkbox
            id="monitor_alarms_setting_Critical"
            [label]="levelText[6]"
            [(ngModel)]="criticalValue"
            (onChange)="onCriticalChange($event)">
        </n-checkbox>
        <n-checkbox
            id="monitor_alarms_setting_Major"
            [label]="levelText[5]"
            [(ngModel)]="majorValue"
            (onChange)="onMajorChange($event)">
        </n-checkbox>
        <n-checkbox
            id="monitor_alarms_setting_Warning"
            [label]="levelText[3]"
            [(ngModel)]="warningValue"
            (onChange)="onWarningChange($event)">
        </n-checkbox>
    </div>
    <n-footer>
        <div class="slide-botton-group interval-20">
            <button pButton
                id="alarms_sound_save_button"
                class="ui-btn-primary"
                type="button"
                (click)="onSave()"
                [label]="saveBtnLabel">
            </button>
            <button pButton
                id="alarms_sound_close_button"
                type="button"
                (click)="onClose()"
                [label]="cancelBtnLabel">
            </button>
        </div>
    </n-footer>
</n-slide-window>
